// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@hardwoods/XDL/types";

import { color } from "@hardwoods/XDL/Utilities";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import { css } from "styled-components";

const stickyMode = (backgroundColor?: string) => css`
    ${xScreen.lte("sm")} {
        position: sticky;
        left: -5px;
        z-index: 2;
        background-clip: padding-box;
        box-shadow: 0 2px 9px -2px ${color("common.black.main", 0.12)};

        ${backgroundColor && `background: ${color(backgroundColor)}`};
    }
`;

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            header: css`
                background: ${color("common.white")};
                border-top: 1px solid ${color("common.gray")};
                border-bottom: 3px solid ${color("common.gray")};
                width: auto;
                text-align: left;
                height: 49px;

                span {
                    color: ${color("text.main")};
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: 1px;
                    line-height: 16px;
                }

                > button {
                    justify-content: flex-start;
                }
            `,
            body: css`
                a {
                    span {
                        font-size: 14px;
                        letter-spacing: 0.01px;
                        line-height: 18px;
                        color: ${color("primary")};
                    }
                    &:hover {
                        text-decoration: underline;
                    }
                }
            `,
            head: css`
                th:first-child {
                    ${stickyMode()}
                }
            `,
            cell: css`
                padding: 15px 12px;
                border-bottom: 0;
                &:first-child {
                    ${stickyMode("common.background")}
                }

                // HSP-710: To make sure that the column doesn't take full width.
                white-space: pre-wrap;
            `,
            // Added th because some tables uses th instead of td.
            row: css`
                & td,
                & th {
                    border-bottom: 1px solid ${color("common.gray")};
                    background: ${color("common.white")};
                }
            `,
            evenRow: css`
                background: ${color("common.white")};
            `,
        },
        cellTypographyProps: {
            size: 15,
            color: "text.main",
            css: css`
                letter-spacing: 0.01px;
                line-height: 18px;
            `,
        },
    },
} as xBaseTheme["dataTable"];
